import { apiGet } from '../api.ts'
import { useQuery } from '@tanstack/react-query'
import { QueryCacheKeys } from '@/api/queryKeys.ts'
import { DISABLE_ALERTS_LIVE_FETCHING } from '@/constant/constant.ts'

export const apiGetFalldetectionLiveAlert = async () => {
    return await apiGet<IResGetFalldetectionLive>(`/alert/falldetection/live`)
}

const useQueryGetUrgentNotification = (enabled = false) => {
    return useQuery({
        enabled: enabled && !DISABLE_ALERTS_LIVE_FETCHING,
        queryKey: QueryCacheKeys.notification.getFalldetectionAlertLive(),
        refetchInterval: 1000,
        queryFn: async () => {
            const { data } = await apiGetFalldetectionLiveAlert()
            return data
        }
    })
}

export default useQueryGetUrgentNotification

export interface IResGetFalldetectionLive {
    falls: IAlertFalldetectionLiveItem[]; // API 응답 필드명 확인 필요, 기존 코드에 맞춤
}

export interface IFalldetectionProtectee {
    id: number;
    name: string;
}

export interface IFalldetectionAlert {
    createdAt: string;
    taskManagerAt: string;
    isMyTask: boolean;
    confirm?: string;
}

export interface IAlertFalldetectionLiveItem {
    id: number;
    protectee: IFalldetectionProtectee;
    alert: IFalldetectionAlert;
}
